import { render } from "./opt-serve.vue?vue&type=template&id=f9a176d6&scoped=true"
import script from "./opt-serve.vue?vue&type=script&lang=js"
export * from "./opt-serve.vue?vue&type=script&lang=js"

import "./opt-serve.vue?vue&type=style&index=0&id=f9a176d6&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a176d6"]])

export default __exports__